import { http, HttpResponse } from 'msw';
import { caseLabelFactory } from '@trukt/factories/caseLabelFactory';
import { mockTruktTmsApiUrl } from '../mocks';
import { CaseLabelsSearchResponse } from '../services/CaseService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/case/labels'), () => {
    return HttpResponse.json<CaseLabelsSearchResponse>({
      page: 1,
      rowCount: 3,
      total: 0,
      rows: 3,
      results: caseLabelFactory.buildList(3),
    });
  }),
];
